/* eslint-disable import/no-cycle */

import { DataService } from '../../../config/dataService/dataService';
import { getQueryString } from '../../../utility/utility';

export const getReferralsListApi = (params = {}) => {
  const { isSuperAdmin, isStaff, ...query } = params;
  const base = isSuperAdmin || isStaff ? '/referrals' : '/merchant/referrals';
  const filtered = Object.fromEntries(
    Object.entries(query).filter(([, v]) => v !== undefined && v !== '' && v !== null),
  );
  const qs = Object.keys(filtered).length ? `?${getQueryString(filtered)}` : '';
  return DataService.get(`${base}${qs}`);
};

export const getReferralDetailsApi = (id, isSuperAdmin, isStaff) =>
  DataService.get(isSuperAdmin || isStaff ? `/referrals/${id}` : `/merchant/referrals/${id}`);

export const getReferralKpisApi = () =>
  DataService.get(`/kpis?${getQueryString({ model: 'Referral' })}`);

export const addReferralApi = (payload) =>
  DataService.post('/merchant/referrals', {
    first_name: payload.first_name,
    last_name: payload.last_name,
    company_name: payload.company_name,
    email: payload.email,
    mobile_number: payload.mobile_number,
  });

export const updateReferralStatusApi = (id, payload) => DataService.patch(`/referrals/${id}/status`, payload);
